const colorsDictionary: Record<string, any> = {
  red: {
    'red-600': '#f56b74',
    'red-700': '#eb3b47',
    'red-800': '#b52831'
  },
  orange: {
    'orange-600': '#ffb355',
    'orange-700': '#ff971e',
    'orange-800': '#bf7211'
  },
  yellow: {
    'yellow-600': '#ffde44',
    'yellow-700': '#fccd03',
    'yellow-800': '#bf9e00'
  },
  green: {
    'green-600': '#53c086',
    'green-700': '#19a45a',
    'green-800': '#0f7f43'
  },
  teal: {
    'teal-600': '#47cbcf',
    'teal-700': '#0ab3b8',
    'teal-800': '#038b8f'
  },
  blue: {
    'blue-600': '#5785ed',
    'blue-700': '#205be0',
    'blue-800': '#1646b3'
  },
  purple: {
    'purple-600': '#be64ff',
    'purple-700': '#a532ff',
    'purple-800': '#7c20bf'
  },
  pink: {
    'pink-600': '#e545af',
    'pink-700': '#d40890',
    'pink-800': '#a4016e'
  },
  gray: {
    'gray-600': '#7f828b',
    'gray-700': '#646464',
    'gray-800': '#3c4048'
  }
};

export const colorDefaultData = {
  colorHex: colorsDictionary.blue['blue-700'],
  colorKey: 'blue-700'
};

export default colorsDictionary;
